var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512.00038",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 169.9940010834,
    x2: 299.4934135904,
    y1: 71.98622701,
    y2: 349.0548448864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0082ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078db"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078db",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006cb5"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 364.2825237824,
    x2: -379.5864327114,
    xlinkHref: "#b",
    y1: 314.0868361356,
    y2: -84.9521808166
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 256.0003,
    x2: 256.0003,
    xlinkHref: "#b",
    y1: 443.733524,
    y2: 495.976118997
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 447.3341798608,
    x2: 298.1907244032,
    xlinkHref: "#b",
    y1: 462.025986762,
    y2: 312.8826316966
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m420.421875 503.234375c-109.503906 11.6875-219.339844 11.6875-328.84375 0-43.664063-4.660156-78.152344-39.148437-82.8125-82.816406-11.6875-109.503907-11.6875-219.335938 0-328.839844 4.660156-43.664063 39.148437-78.152344 82.8125-82.8125 109.503906-11.6875 219.335937-11.6875 328.839844 0 43.667969 4.660156 78.15625 39.148437 82.816406 82.8125 11.6875 109.503906 11.6875 219.335937 0 328.839844-4.660156 43.667969-39.144531 78.15625-82.8125 82.816406zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m475.386719 110.097656c-4.132813-38.746094-34.734375-69.351562-73.484375-73.488281-97.171875-10.367187-194.632813-10.367187-291.804688 0-38.746094 4.136719-69.351562 34.742187-73.488281 73.488281-10.367187 97.171875-10.367187 194.632813 0 291.800782 4.136719 38.75 34.742187 69.355468 73.488281 73.488281 97.171875 10.371093 194.632813 10.371093 291.800782 0 38.75-4.132813 69.355468-34.738281 73.488281-73.488281 10.371093-97.167969 10.371093-194.628907 0-291.800782zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.671875 409.804688c.351563 3.539062.714844 7.078124 1.09375 10.617187 4.660156 43.664063 39.148437 78.152344 82.816406 82.8125 109.503907 11.6875 219.335938 11.6875 328.839844 0 43.667969-4.660156 78.152344-39.148437 82.8125-82.8125.378906-3.539063.742187-7.078125 1.097656-10.617187zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m503.234375 420.417969c4.835937-45.3125 7.664063-90.679688 8.5-136.058594l-137.382813-137.382813c-28.871093-30.441406-71.1875-49.660156-118.351562-49.660156-87 0-157.527344 65.375-157.527344 146.015625 0 39.6875 17.097656 75.664063 44.820313 101.980469 1.824219 1.925781 12.996093 13.066406 13.875 13.945312l.597656 48.503907c.054687 4.4375 1.84375 8.679687 4.980469 11.816406l92.417968 92.417969c55.113282.03125 110.226563-2.890625 165.253907-8.761719 43.671875-4.660156 78.15625-39.148437 82.816406-82.816406zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m256 97.316406c-87 0-157.527344 65.375-157.527344 146.015625 0 45.9375 22.890625 86.910157 58.667969 113.675781l.636719 51.484376c.03125 2.78125 3.039062 4.507812 5.460937 3.132812l49.195313-27.9375c13.835937 3.683594 28.453125 5.660156 43.566406 5.660156 87 0 157.527344-65.375 157.527344-146.015625s-70.527344-146.015625-157.527344-146.015625zm11.960938 193.078125-33.671876-35.046875c-1.972656-2.054687-5.074218-2.542968-7.582031-1.191406l-59.085937 31.816406c-2.25 1.210938-4.457032-1.667968-2.707032-3.527344l69.820313-74.011718c2.003906-2.121094 5.378906-2.121094 7.378906.003906l33.660157 35.71875c1.976562 2.101562 5.117187 2.601562 7.652343 1.222656l58.0625-31.613281c2.25-1.222656 4.46875 1.660156 2.714844 3.523437l-68.894531 73.070313c-1.988282 2.109375-5.335938 2.125-7.347656.035156zm0 0",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.c47fa80791b3d348a7c6cc5f869ddccd.svg";
export { ForwardRef as ReactComponent };